const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { default: fetch } = require('node-fetch');

async function getNewDog(state) {let response, message, bits;
  state.loading = true;
  try {
    response = await fetch('https://dog.ceo/api/breeds/image/random');
  } catch(e) {
    console.log(e);
    state.loading = e.message;
    return 
  }
  message = (await response.json()).message;
  bits = message.split('/');
  state.loading = false;


  state.dogPage.choice = ({ url: message, breed: bits[4], image: bits[5] });
};
module.exports = { fetch, getNewDog };
